import { CUSTOMER_TYPES } from '../../../resources/enums';
import { CustomerPerson, Person } from '../../../resources/types';
import { getPhoneNumberFromShortCodeFormat, safeDate } from '../../../utilities/miscFunctions';
import { Account, IAccount } from '../account/Account';
import { User } from '../User';
import { IAddress, ICustomer } from './ICustomer';

export class Customer {
  id: string;
  email: string;
  type: CUSTOMER_TYPES;
  status: string;
  branch: string;
  accounts: Account[];
  createdAt: Date | null;
  updatedAt: Date | null;
  phone: string;
  address: IAddress;
  branch_id: string;
  picture?: string;
  picture_url: string;
  total_accounts?: number;
  person_id: string;
  primaryContact: Person;
  name: string;
  members: CustomerPerson[];
  relationshipManager: User | null;

  constructor(IModel: ICustomer) {
    this.id = IModel.id;
    this.email = IModel.email;
    this.type = IModel.type as CUSTOMER_TYPES;
    this.status = IModel.status;
    this.branch = IModel.branch;
    this.accounts = IModel.accounts ? IModel.accounts.map((acct: IAccount) => new Account(acct)) : [];
    this.createdAt = safeDate(IModel.created_at);
    this.updatedAt = safeDate(IModel.updated_at);
    this.phone = getPhoneNumberFromShortCodeFormat(IModel.phone);
    this.address = IModel.address;
    this.branch_id = IModel.branch_id;
    this.picture = IModel.picture ?? "";
    this.total_accounts = IModel.total_accounts ?? 0;
    this.picture_url = IModel.picture_url ?? "";
    this.person_id = IModel.person_id;
    this.primaryContact = IModel.person;
    this.name = IModel.name;
    this.members = IModel.members;
    this.relationshipManager = IModel.relationship_manager ? new User(IModel.relationship_manager) : null;
  }

  getCustomerName(): string {
    return this.name;
  }

  isPersonal(): boolean {
    return this.type === CUSTOMER_TYPES.PERSONAL;
  }
}

export const BLANK_CUSTOMER_DATA = {
  id: "",
  name: "",
  tin: "",
  region: "",
  city: "",
  type: "",
  email: "",
  phone: "",
  streetAddress: "",
  digitalAddress: "",
  branch_id: "",
  person_id: null,
  members: [],
}
